import { render, staticRenderFns } from "./MarkAsInactiveModal.vue?vue&type=template&id=95457164&scoped=true"
import script from "./MarkAsInactiveModal.vue?vue&type=script&lang=js"
export * from "./MarkAsInactiveModal.vue?vue&type=script&lang=js"
import style0 from "./MarkAsInactiveModal.vue?vue&type=style&index=0&id=95457164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95457164",
  null
  
)

export default component.exports